import { useState, useEffect } from 'react';

/**
 * 입력값에 디바운스를 적용하는 훅.
 * value가 변경된 후 delay(ms) 동안 추가 변경이 없으면 debouncedValue를 갱신한다.
 */
export function useDebounce<T>(value: T, delay: number): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => clearTimeout(timer);
  }, [value, delay]);

  return debouncedValue;
}